import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import './AppMenu.scss';

export default function AppMenu({ options = [] }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation(); // Prevent the click event from propagating to parent elements
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (callback) => {
    setAnchorEl(null);
    if (typeof callback === 'function') {
      callback();
    }
  };

  return (
    <div>
      {/* Trigger Button using Iconify */}
      <IconButton
        // id="icon-menu-button"
        className='icon-trigger'
        aria-controls={open ? 'icon-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <Icon icon="ph:dots-three-vertical" height={16}/>
      </IconButton>

      {/* The MUI Menu */}
      <Menu
        id="icon-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={(e) => {e.stopPropagation(); handleClose(null)}}
        MenuListProps={{
          'aria-labelledby': 'icon-menu-button',
        }}
        // Optional: Adds a nice clean slide/fade layout elevation shadow
        slotProps={{
          paper: {
            elevation: 1,
            style: { minWidth: '200px', borderRadius: 10 }
          }
        }}
      >
        {options.map((option, index) => (
          <MenuItem 
            key={index} 
            onClick={(e) => {e.stopPropagation(); handleClose(option.onClick)}}
            disabled={option.disabled}
            style={{padding: '8px 16px', color: option.color === 'red' ? '#DC2626' : 'inherit'}}
          >
            {/* Optional: If you pass an icon for the menu list items */}
            {option.icon && (
              <ListItemIcon style={{ minWidth: '30px', color: 'inherit' }}>
                <Icon icon={option.icon} height={18} />
              </ListItemIcon>
            )}
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}